import { render, staticRenderFns } from "./collapse-item.vue?vue&type=template&id=3f56c35c&scoped=true&"
import script from "./collapse-item.component.ts?vue&type=script&lang=ts&"
export * from "./collapse-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./collapse-item.vue?vue&type=style&index=0&id=3f56c35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56c35c",
  null
  
)

export default component.exports